import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useGetUsersWithoutRoleQuery, useSetClientAdminMutation } from '../../../generated/graphql';
import { FormAutoComplete } from '../../form';
import styles from './NewClientAdminDialog.module.css';

type NewClientAdminDialogProps = {
    onClose: () => void,
    clientId: string,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewClientAdminDialog = (props: NewClientAdminDialogProps) => {
    const { style, visible, clientId, onClose } = props;
    const [searchUser, setSearchUser] = useState('');
    const [setClientAdmin, setClientAdminResult] = useSetClientAdminMutation();
    const [validationError, setValidationError] = useState('');
    const users = useGetUsersWithoutRoleQuery({
        variables: { contains: searchUser }
    });

    const handleSubmit = () => {
        const selectedEmail = users.data?.UserList?.nodes?.filter(u => u?.email === searchUser)[0];
        if (!searchUser) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        if (!selectedEmail) {
            setValidationError('Please Select A Valid Email!');
            return;
        }
        setValidationError('');
        setClientAdmin({
            variables: { id: clientId, userId: selectedEmail?.id }
        })
            .then(() => onClose())
            .catch(() => {});
    };

    return (
        <DialogBase
            title="New Client Admin"
            type="OkCancel"
            isLoading={setClientAdminResult.loading}
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            className={styles.NewClientAdminDialog}
            style={style}
            data-testid="NewClientAdminDialog">
            <FormAutoComplete
                label="Email"
                name="email"
                value={searchUser}
                onChange={setSearchUser}
                options={(users.data?.UserList?.nodes?.map(c => c?.email) || []).filter((e): e is string => !!e)}
            />
        </DialogBase>
    );
};

export default NewClientAdminDialog;